import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Mentors from './pages/Mentors';

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Rowdies', sans-serif" },
        body: { value: "'Space Grotesk', sans-serif" },
      },
      colors: {
        navy: {
          DEFAULT: { value: '#0A1A3A' },
          dark: { value: '#050D1D' },
        },
        offwhite: {
          DEFAULT: { value: '#F5F5F5' },
          dark: { value: '#E5E5E5' },
        },
        electric: {
          DEFAULT: { value: '#1A8FE3' },
          dark: { value: '#1572B6' },
        },
        teal: {
          DEFAULT: { value: '#066466' },
          dark: { value: '#044D4E' },
        },
      },
    },
    semanticTokens: {
      colors: {
        bg: { value: '{colors.navy.DEFAULT}' },
        fg: { value: '{colors.offwhite.DEFAULT}' },
        primary: { value: '{colors.electric.DEFAULT}' },
        secondary: { value: '{colors.teal.DEFAULT}' },
      },
    },
  },
});

function App() {
  return (
    <ChakraProvider value={system}>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/mentors" element={<Mentors />} />
          </Routes>
          <Footer />
          <ScrollToTop />
        </BrowserRouter>
      </div>
    </ChakraProvider>
  );
}

export default App;
